export default {
    name: 'ManualVerification'
}